export default {
    name: 'ManualVerification'
}